
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/mss",
      function () {
        return require("private-next-pages/cases/mss/index.tsx");
      }
    ]);
  